// Minimal History-API router.
//
// The `Router` class is shared via the d3-kit `spa/` primitives (bundled via
// lit.js). Routes are app-specific, so the library ships only the class and the
// portal owns the singleton below; route registration lives in community-app.js.
import { Router } from './lit.js';

export { Router };

export const router = new Router();
